import React, {Component, useEffect, useMemo, useContext} from "react";
import {renderToStaticMarkup} from "react-dom/server";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Routes, Route, Navigate, useNavigate} from "react-router";
import _ from "lodash";
import {Button, Modal, Progress, Spin, Menu, Dropdown} from "antd";
import "./style/MainView.less";
import {UNSAFE_RouteContext, useLocation} from "react-router-dom";
import {DownOutlined} from "@ant-design/icons";
import queryString from "query-string";
import MainActions from "../../action/main/MainActions";

import MenuView from "./MenuView";
import TestView from "./TestView";
import RouteMenu from "./RouteMenu";
import MenuConfig from "./MenuConfig";
import AppNameSvg from "../../asset/icon/AppName.svg";
import WeiHuiNameSvg from "../../asset/icon/WeiHuiName.svg";
import WeiHuiLogoSvg from "../../asset/icon/WeiHuiLogo.svg";
import ExpiredPng from "../../asset/image/Expired.png";
import SwjwLogoSvg from "../../asset/icon/SwjwLogo.svg";
import "whatwg-fetch";
import NoPermissionPng from "../../asset/image/NoPermission.png";
import AppName1Svg from "../../asset/icon/AppName1.svg";
import AppContext from "../../application/AppContext";
import FunctionUtil from "../../util/FunctionUtil";
import RouteUtil from "../../util/RouteUtil";
import ExpireNotifyModal from "../../component/expirenotifymodal/ExpireNotifyModal";
import AccountSettingView from "../accountsetting/AccountSettingView";
import ZoomUp from "../../component/transition/ZoomUp";
import BindAccountView from "../bindAccount/BindAccountView";
import LoginImageColoredPng from "../../asset/icon/LoginImageColored.png";
import AppLogoSvg from "../../asset/icon/AppLogo.svg";
import SwjwLoginView from "../swjwlogin/SwjwLoginView";
import OtherConfig from "../other/Config";
import ClientSelectView from "../other/ClientSelectView";
import UnderlayAppPng from "../../asset/image/UnderlayApp.png";
import BusinessConstants from "../../constant/BusinessConstants";
import iconCompMap from "../systemsetting/appmodule/iconCompMap";
import UnderlayTranferPcPng from "../../asset/image/UnderlayTranferPc.png";


const DataCabinView = React.lazy(() => import("./DataCabinView"));
const isSwjwMode = __IS_SWJW__;
const isUnderlay = __IS_UNDERLAY__;

const initialFavicon = document.querySelector("link[rel~='icon']");
const defaultFavicon = initialFavicon == null
    ? null
    : {href: initialFavicon.href, type: initialFavicon.type};

function updateFavicon(module) {
    let favicon = document.querySelector("link[rel~='icon']");
    if (favicon == null) {
        favicon = document.createElement("link");
        favicon.rel = "icon";
        document.head.appendChild(favicon);
    }

    const IconComp = iconCompMap[module];
    if (IconComp == null) {
        if (defaultFavicon != null) {
            favicon.href = defaultFavicon.href;
            if (_.isEmpty(defaultFavicon.type)) {
                favicon.removeAttribute("type");
            } else {
                favicon.type = defaultFavicon.type;
            }
        }
        return;
    }

    const svg = renderToStaticMarkup(
        <IconComp style={{color: "#144CD0"}} />
    );
    favicon.type = "image/svg+xml";
    favicon.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/**
 * 获取当前RouterContext下的pathname
 */
function useContextPathname() {
    const {
        matches: parentMatches,
    } = useContext(UNSAFE_RouteContext);
    const location = useLocation();
    const pathname = location.pathname || "/";
    // https://github.com/remix-run/react-router/blob/main/packages/react-router/index.tsx

    const routeMatch = _.last(parentMatches);
    const parentPathnameBase = routeMatch?.pathnameBase ?? "/";

    return parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
}

export function getAppLogoAndAppName() {
    let appLogo = <AppNameSvg style={{color: "#FFF", fontSize: 36}} />;
    let appName;

    if (__IS_UNDERLAY__ && !__IS_INHOS__) { // 基座云
        appLogo = <img src={UnderlayAppPng} style={{width: 36}} />;
        appName = "连帆智护云";
    } else if (__IS_SWJW__) { // 卫健委模式
        if (AppContext.isSwjw) { // 卫健委医院
            appName = "湖州市医疗业务管理平台";
            appLogo = null;
        } else {
            appLogo = <AppLogoSvg style={{color: "#FFF", fontSize: 36}} />;
            appName = "微晖医院管理";
        }
    } else {
        appLogo = <AppLogoSvg style={{color: "#FFF", fontSize: 36}} />;
        appName = "微晖医院管理";
    }

    
    if (AppContext.hospitalConfig?.logoBase64 != null) {
        appLogo = <img src={AppContext.hospitalConfig.logoBase64} height={36} width={36} />;
    }
    if (AppContext.hospitalConfig?.appName != null) {
        appName = AppContext.hospitalConfig?.appName;
    }


    return {appLogo, appName};
}

const headerHeight = 60;
const menuWidth = 220;


function MainView({dataContext, actions}) {
    const navigate = useNavigate();
    useEffect(() => {
        actions.getData({navigate});
    }, []);

    const renderUnderlayTransfered = () => {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    display: "flex",
                    flexFlow: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <img src={UnderlayTranferPcPng} style={{width: "100vw", height: "100vh"}} />
            </div>
        );
    };

    const renderExpired = () => {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    display: "flex",
                    flexFlow: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <img src={ExpiredPng} style={{width: 340}} />
                <div
                    style={{
                        fontSize: 18,
                        color: "#485D69",
                        fontWeight: "bold",
                        marginTop: 32,
                    }}
                >
                    人员管理
                </div>
                <div
                    style={{
                        fontSize: 14,
                        color: " #A5B6BE",
                        marginTop: 4,
                    }}
                >
                    系统使用已到期，购买请联系：400-850-2660
                </div>
            </div>
        );
    };

    if (dataContext.isExpired) {
        return renderExpired();
    }

    if (dataContext.isUnderlayTransfered) {
        return renderUnderlayTransfered();
    }

    if (dataContext.isExecuting) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Spin size="large" tip="正在初始化数据..." />
            </div>
        );
    } else if (dataContext.isBindAccount) {
        return (<BindAccountView />);
    } else if (dataContext.error != null || AppContext.user == null) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Spin size="large" tip="通讯录同步中，请耐心等待10分钟后再重试..." />
            </div>
        );
    } else {
        return (
            <Content
                dataContext={dataContext}
                actions={actions}
            />
        );
    }
}

const getMenuItems = (configs, navigate, level = 0, baseUrl = "") => {
    return _.map(configs, (it) => {
        const rawPath = _.isEmpty(baseUrl)
            ? it.key
            : `${baseUrl}/${it.key}`;
        const path = _.startsWith(rawPath, "/")
            ? rawPath
            : `/${rawPath}`;

        let labelStyle;
        if (it.icon != null) {
            labelStyle = {
                fontWeight: "bold",
            };
        } else if (level > 0) {
            labelStyle = {
                marginLeft: 12,
            };
        }
        const label = (
            <span style={labelStyle}>
                {it.name ?? it.getName?.()}
            </span>
        );
        const item = {
            key: path,
            label,
            icon: it.icon,
            onClick: _.isEmpty(it.children) || (level === 0 && isUnderlay)
                ? () => navigate(path)
                : null,
        };

        if (!_.isEmpty(it.children)) {
            item.children = getMenuItems(it.children, navigate, level + 1, path);
        }

        return item;
    });
};

function Content({dataContext, actions}) {
    const {appLogo, appName} = getAppLogoAndAppName();
    const navigate = useNavigate();
    const pathname = useContextPathname();
    const normalizedPathname = _.startsWith(pathname, "/")
        ? pathname
        : `/${pathname}`;

    const pathSegments = normalizedPathname.split("/").filter(Boolean);
    const selectedTopLevelKey = _.isEmpty(pathSegments)
        ? "/"
        : `/${_.first(pathSegments)}`;

    useEffect(() => {
        if (!isUnderlay) {
            return undefined;
        }

        const topLevelRouteKey = _.first(pathSegments);
        let module;
        if (topLevelRouteKey === "function") {
            module = BusinessConstants.UNDERLAY_APP_MODULE_TYPE.ARCHIVE;
        } else if (topLevelRouteKey === "medigroup") {
            module = BusinessConstants.UNDERLAY_APP_MODULE_TYPE.MED_GROUP;
        } else {
            module = _.find(
                AppContext.hospitalConfig?.redirectConfigs,
                config => config.module !== BusinessConstants.UNDERLAY_APP_MODULE_TYPE.CUSTOM
                    && _.toLower(config.module) === topLevelRouteKey
            )?.module;
        }

        updateFavicon(module);
        return () => updateFavicon();
    }, [selectedTopLevelKey]);

    const [topLevelMenuItems, subMenuItemMap, flatRoutes, allMenuItems] = useMemo(() => {
        const allRoutes = MenuConfig.getMenu();
        const filterRoutes = MenuConfig.filterRouteConfigs(allRoutes);
        const menuItems = getMenuItems(filterRoutes, navigate);
        
        return [
            _.filter(_.map(menuItems, (it) => {
                return _.omit(it, ["children"]);
            }), Boolean),
            _.chain(menuItems)
                .keyBy(it => it.key)
                .mapValues(it => it.children)
                .value(),
            RouteUtil.getRoutes(_.concat([...filterRoutes, ...OtherConfig.routes])),
            _.filter(menuItems, Boolean),
        ];
    }, [AppContext.user]);

    flatRoutes.unshift(
        <Route
            key="/datacabin"
            path="/datacabin"
            element={(
                <React.Suspense
                    fallback={(
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Spin size="large" tip="加载中..." />
                        </div>
                    )}
                >
                    <DataCabinView />
                </React.Suspense>
            )}
        />,
        <Route
            key="index"
            index
            element={<Navigate replace to={_.first(topLevelMenuItems)?.key} />}
        />
    );

    const isEmpty = topLevelMenuItems?.length === 0;
    const {embed} = queryString.parse(window.location.search);
    const showTopMenu = !embed;
    return (
        <div
            style={{
                position: "fixed",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {
                showTopMenu && (
                <div
                    style={{
                        height: headerHeight,
                        display: "flex",
                        alignItems: "center",
                        background: isUnderlay ? "#144CD0" : "linear-gradient(90deg, rgb(52, 191, 251) 0%, rgb(31, 141, 247) 100%)",
                        overflow: "hidden",
                        padding: "0 20px",
                    }}
                >
                    <div
                        style={{display: "flex", alignItems: "center"}}
                    >
                        {appLogo}
                        {appName != null
                            ? <div className="logoName" style={{fontSize: 22, color: "#fff", marginLeft: 5}}>{appName}</div>
                            : null
                        }
                    </div>
                    {/*                     {
                        AppContext.isSwjw
                            ? <div className="logoName" style={{fontSize: 22, color: "#fff", marginLeft: 5}}>湖州市医疗业务管理平台</div>
                            : (
                                <div style={{display: "flex", alignItems: "center"}}>
                                    {
                                        AppContext.hospitalConfig?.logoBase64 != null
                                            ? <img src={AppContext.hospitalConfig.logoBase64} height={36} width={36} />
                                            : <AppLogoSvg style={{color: "#FFF", fontSize: 36}} />
                                    }
                                    <div className="logoName" style={{fontSize: 22, color: "#fff", marginLeft: 5}}>{AppContext.hospitalConfig?.appName ?? "微晖医院管理"}</div>
                                </div>
                            )
                    } */}
                    <div style={{flex: 1}}>
                        {
                            isUnderlay && (
                            <Menu
                                items={topLevelMenuItems}
                                selectedKeys={[selectedTopLevelKey]}
                                mode="horizontal"
                                className="renyuan-top-menu"
                                onClick={({key}) => {
                                    if (key === "/medischedule") {
                                        location.replace("http://h5.attendance.grapeunion.com.cn:8888/ ");
                                    }
                                }}
                                style={{
                                    flex: 1,
                                    background: "transparent",
                                    borderBottom: "none",
                                    marginLeft: 20,
                                    color: "#fff",
                                }}
                            />
                            )
                        }
                    </div>
                    <div style={{
                        flex: "none",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                    }}
                    >
                        <Dropdown
                            trigger={["hover"]}
                            menu={{
                                items: [
                                    AppContext.isSwjw ? null : {key: "setting", label: "账户设置"},
                                    AppContext.isSwjw ? null : {type: "divider"},
                                    {key: "logout", label: "退出登录"},
                                ].filter(Boolean),
                                onClick: ({key}) => {
                                    if (key === "setting") {
                                        actions.update({accountSettingVisible: true});
                                    } else if (key === "logout") {
                                        actions.logout();
                                    }
                                },
                            }}
                        >
                            <div style={{display: "flex", alignItems: "center"}}>
                                {dataContext.user.avatar
                                    ? (
                                        <img style={{flex: "none", height: 36, width: 36, borderRadius: "50%", marginRight: 8}}
                                            src={decodeURI(dataContext.user.avatar)}
                                        />
                                    )
                                    : null}

                                <div style={{flex: "none", fontSize: 14}}>{dataContext.user.name}</div>
                                <DownOutlined style={{marginLeft: 10}} />
                            </div>
                        </Dropdown>
                    </div>
                </div>
                )
            }
            {((installStatus) => {
                const noLeftMenu = (isUnderlay && (_.isEmpty(subMenuItemMap[selectedTopLevelKey]) || selectedTopLevelKey === "/index")) || embed;

                let content = (
                    <div
                        style={{
                            flex: 1,
                            overflow: "hidden",
                            position: "relative",
                            display: "flex",
                            flexFlow: "column nowrap",
                        }}
                    >
                        <div style={{
                            flex: 1,
                            display: "flex",
                            zIndex: 0,
                            overflow: "hidden",
                        }}
                        >
                            {noLeftMenu
                                ? null
                                : (
                                    <RouteMenu
                                        items={!isUnderlay ? allMenuItems : subMenuItemMap[selectedTopLevelKey]}
                                        selectedKeys={[normalizedPathname]}
                                        openKeys={dataContext.openMenuKeys}
                                        onOpenChange={actions.setOpenKeys}
                                        mode="inline"
                                        routes={!isUnderlay ? allMenuItems : subMenuItemMap[selectedTopLevelKey]}
                                        top={headerHeight}
                                        width={menuWidth}
                                    />
                                )}

                            <div
                                style={{
                                    flex: 1,
                                    overflow: "hidden",
                                    background: "#F3F6F8",
                                    display: "flex",
                                    flexFlow: "column nowrap",
                                    marginLeft: noLeftMenu ? null : menuWidth,
                                }}
                            >
                                <Routes>
                                    {flatRoutes}
                                </Routes>
                            </div>
                        </div>
                    </div>
                );

                if ((!AppContext.isSwjw && installStatus.unitCount == null) || AppContext.user == null /* || AppContext.user.nurseUnit == null */) {
                    content = null;
                } else {
                    if (isEmpty) {
                        content = (
                            <div style={{flex: 1, display: "flex", flexFlow: "column nowrap", justifyContent: "center", alignItems: "center"}}>
                                <img style={{marginBottom: 28}} src={NoPermissionPng} />
                                <div style={{fontSize: 18, color: "#485D69", fontWeight: "bold", marginBottom: 4}}>人员管理</div>
                                <div style={{color: "#90A4AD"}}>暂无权限，请在手机端查看</div>
                            </div>
                        );
                    }
                }

                return content;
            })(dataContext.installStatus)}

            {dataContext.dingSynVisible
                ? (
                    <Modal
                        prefixCls="numas-modal"
                        width={340}
                        height={280}
                        visible
                        maskClosable={false}
                        closable={false}
                        footer={null}
                    >
                        <div style={{flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                            <div style={{fontSize: 20, fontWeight: "bold", lineHeight: "70px"}}>人员列表同步中…</div>
                            <Progress type="circle" percent={dataContext.dingSynProgress} />
                            <div style={{lineHeight: "70px"}}>
                                大概需要几分钟，请耐心等待
                            </div>
                        </div>
                    </Modal>
                )
                : null}

            {dataContext.showExpireNotify && (
                <ExpireNotifyModal
                    isExpired={dataContext.isExpired}
                    expiredDays={dataContext.expiredDays}
                />
            )}

            <ZoomUp visible={dataContext.accountSettingVisible}>
                <AccountSettingView
                    onClose={() => actions.update({accountSettingVisible: false})}
                />
            </ZoomUp>
        </div>
    );
}


export default connect(
    state => ({
        dataContext: state.mainViewModel,
    }),
    dispatch => ({
        actions: bindActionCreators(MainActions, dispatch),
    })
)(MainView);
